const Blank = () => {
	return <div className='py-4 md:py-10'></div>;
};

export default Blank;
